<template>
  <div class="layout connection">
    <div class="connection-content">
        <div class="cc-tab">
          <div
            class="cc-tab-item"
            :class="{active: index === idx}"
            v-for="(item, index) in tabArr"
            :key="'tab-' + index"
            @click="linkToTab(index)"
          >{{item.title}}</div>
        </div>
      <!-- <div class="cc-tab-content" v-if="idx === 0">
        <van-list v-model="majorLoading" :majorFinished="majorFinished" majorFinished-text="没有更多了" @load="onLoad">
          <div class="cc-box">
            <div class="cc-list" v-for="(item, index) in list" :key="'cc-list-' + index">
              <div class="cc-list-l">
                <img
                  src="http://img3.imgtn.bdimg.com/it/u=2326371930,2324774527&fm=26&gp=0.jpg"
                />
              </div>
              <div class="cc-list-r">
                <div class="title">钟南山</div>
                <div
                  class="info"
                >钟南山，男，汉族，福建厦门人，1936年10月出生于南京，中共党员，中国工程院院士，著名呼吸病学专家，中国抗击非典型肺炎的领军人物，曾任广州医学院院长、党委书记，广州市呼吸疾病研究所所长、广州呼吸疾病国家重点实验室主任、中华医学会会长。</div>
                <div class="txt">话题讨论：积极防护，保护自己。戴口罩，勤洗手。</div>
              </div>
            </div>
          </div>
        </van-list>
      </div> -->
      <majorList v-if="idx === 0 "></majorList>
      <addedList v-if="idx === 1 "></addedList>
    </div>
    <commBuyerMask v-if="user.userRole<2"></commBuyerMask>
    <layoutFooter></layoutFooter>
  </div>
</template>

<script>
import commBuyerMask from "@/components/comm-buyer-mask";
import layoutFooter from "@components/layout-footer";
import { mapActions, mapGetters, mapMutations } from "vuex";
import majorList from "./components/major-list";
import addedList from "./components/added-list";
export default {
  name: "connection",
  components: {
    commBuyerMask,  
    layoutFooter,
    majorList,
    addedList
  },
  data() {
    return {
      idx: 0, // tab索引
      tabArr: [
        { title: "专业买家" },
        { title: "最近新增" }
      ],
    };
  },
  computed: {
    ...mapGetters({
      user:"getUserInfo",       //用户身份 0 游客
      exhibitionId:'getExhibitionId',
    }),
    
  },
  created() {
    this.getUser(this.exhibitionId);
  },
  methods: {
    ...mapActions({
      getUser: 'login/getUser'
    }),
    linkToTab(index) {
      this.idx = index;
    },
  }
};
</script>

<style lang="scss" scoped>
.connection {
  background: #131825;
  color: #fff;
  font-size: 0.2rem;
  &-content {
    padding-top: 1rem;
  }
  .cc {
    &-tab {
      display: flex;
      justify-content: space-around;
      font-size: 0.24rem;
      padding: 0.23rem 0;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background:#131825;
      z-index: 99;
      &-item {
        width: 2.4rem;
        height: 0.54rem;
        line-height: 0.54rem;
        text-align: center;
        &.active {
          background: #f85b0f;
          border-radius: 0.04rem;
          position: relative;
          &::after {
            position: absolute;
            bottom: -0.09rem;
            left: 50%;
            transform: translateX(-50%);
            content: "";
            border-width: 0.1rem 0.1rem 0;
            border-style: solid;
            border-color: transparent;
            border-color: #f85b0f transparent transparent transparent;
          }
        }
      }
      &-content {
        .cctc-title {
          display: flex;
          padding: 0.14rem 0.24rem 0.24rem;
          align-items: center;
          justify-content: space-between;
          .info {
            font-size: 0.2rem;
            color: #bfbfbf;
            margin-right: 0.2rem;
            max-width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            .num {
              color: #fff;
            }
          }
          .change {
            color: #f85b0f;
          }
          .btn {
            flex: 1;
            text-align: right;
            button {
              background-color: transparent;
            }
          }
        }
      }
    }
    &-box {
      padding: 0 0.24rem;
    }
    &-list {
      margin-bottom: 0.2rem;
      padding: 0.2rem;
      background-color: #1d2435;
      display: flex;
      &-l {
        width: 1.8rem;
        height: 2.3rem;
        border-radius: 0.05rem;
        position: relative;
        margin-right: 0.17rem;
        img {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          margin: auto;
          max-width: 100%;
          max-height: 100%;
          background-color: #ff4550;
          border-radius: 0.05rem;
        }
      }
      &-r {
        width: calc(100% - 1.97rem);
        color: #fff;
        .title {
          font-size: 0.24rem;
          margin-bottom: 0.16rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .info {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          font-size: 0.2rem;
          margin-bottom: 0.5rem;
        }
        .txt {
          font-size: 0.18rem;
          color: #bfbfbf;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    &-box2 {
      padding: 0 0.24rem;
      .cc-list2 {
        padding: 0.2rem;
        margin-bottom: 0.2rem;
        background-color: #1d2435;
        border-radius: 0.05rem;
        color: #fff;
        &-t {
          margin-bottom: 0.28rem;
          display: flex;
          .logo {
            position: relative;
            width: 0.88rem;
            height: 0.88rem;
            margin-right: 0.14rem;
            img {
              border-radius: 50%;
              width: 100%;
              height: 100%;
              // object-fit: cover;
            }
          }
          .details {
            
            .line {
              display: flex;
              align-items: flex-end;
              margin-bottom: 0.16rem;
              padding-top: 0.1rem;
              .name {
                font-size: 0.24rem;
                margin-right: 0.1rem;
                font-weight: 400;
              }
              .job {
                font-size: 0.2rem;
              
              }
            }
            .info2 {
              font-size: 0.2rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .txt {
            width: 2rem;
            padding-top: 0.16rem;
            text-align: right;
            font-size: 0.2rem;
            color: #bfbfbf;

            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        &-gx{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &-b {
          display: flex;
          .cclb {
            &-l {
              font-size: 0.2rem;
              width: 80%;
              padding-top: 0.13rem;
              .txt2 {
                color: #ffcc00;
                width: calc(100% - 1px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .txt3 {
                width: calc(100% - 1px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            &-r {
              width: 20%;
              text-align: right;
              .btn {
                height: 0.48rem;
                line-height: 0.48rem;
                display: inline-block;
                padding: 0 0.2rem;
                background-color: #f85b0f;
                border-radius: 0.04rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>